angular.module('rjmNg.common.api').factory 'InputConnections', [
  '$q'
  'AbstractConnections'
  'connectionUtils'
  (
    $q
    AbstractConnections
    connectionUtils
  ) ->

    (clientId) ->
      ConnectionsInstance = AbstractConnections(clientId, "input-connections")

      # Sets _integrationConfig
      updateIntegrationConfig = (connection) ->
        deferred = $q.defer()
        connectionUtils.getIntegrationConfigForConnection(clientId, connection, true).then (config) ->
          connection._integrationConfig = config
          deferred.resolve()
        , (error) ->
          connection._integrationConfig = {}
          deferred.resolve()

        return deferred.promise

      addSupplementalProperties = (connection) ->
        promises = [
          updateIntegrationConfig(connection)
        ]

        return $q.all(promises)

      get = (includeSupplementalProperties = false) ->
        connectionList = null
        connectionsDeferred = $q.defer()

        ConnectionsInstance.get(null, {include_deleted: false}).then (connections) ->
          # Filter out any "Setup Incomplete" GA connections and treat them as deleted
          connectionList = connections.filter (connection) ->
            connection.name.indexOf("(Setup Incomplete)") is -1

          if includeSupplementalProperties
            supplementalPromises = connections.map (connection) ->
              addSupplementalProperties(connection)

            $q.all(supplementalPromises).then () ->
              connectionsDeferred.resolve connectionList
          else
            connectionsDeferred.resolve connectionList

        , connectionsDeferred.reject

        return connectionsDeferred.promise

      getById = (connectionId, includeSupplementalProperties = false) ->
        deferred = $q.defer()

        get(includeSupplementalProperties).then (_connectionList) ->
          connection = _.findWhere _connectionList, {id: +connectionId}

          if connection?
            deferred.resolve connection
          else
            deferred.reject()

        , deferred.reject

        return deferred.promise

      getByMetaId = (metaId, includeSupplementalProperties = false) ->
        deferred = $q.defer()

        get(includeSupplementalProperties).then (_connectionList) ->
          connection = _.findWhere _connectionList, {meta_id: +metaId}

          if connection?
            deferred.resolve connection
          else
            deferred.reject()

        , deferred.reject

        return deferred.promise

      save = (connection, removeCreds = false) ->
        deferred = $q.defer()

        connectionToSave = angular.copy connection

        if removeCreds then delete connectionToSave.credentials
        delete connectionToSave.namespace
        delete connectionToSave.tokens
        delete connectionToSave._integrationConfig

        ConnectionsInstance.save(connectionToSave).then (savedConnection) ->
          angular.extend connection, savedConnection
          deferred.resolve(connection)
        , deferred.reject

        return deferred.promise

      test = (connectionId, connectionType, testRequest) ->
        deferred = $q.defer()

        ConnectionsInstance.test(connectionId, connectionType, testRequest).then (connectionState) ->
          deferred.resolve(connectionState)
        , deferred.reject

        return deferred.promise

      {
        get
        getById
        getByMetaId
        save
        test
        getProfiles: ConnectionsInstance.getProfiles
        deleteTemporarySecrets: ConnectionsInstance.deleteTemporarySecrets
      }
]
